module.exports = __webpack_public_path__ + "static/media/medicine.27ce31e6.jpg";